import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions } from "../redux/receiptTrackingSaga";
import { actions as rtReducerActions } from "../redux/receiptTrackingSlice";
import { ReceiptTrackingSearchForm } from "./ReceiptTrackingSearchForm";
import { ReceiptDetails } from "../assets/components/ReceiptDetails";

import DataTable from "react-data-table-component";
import { Button, Spinner, Alert, Fade } from "react-bootstrap";
import { format } from "date-fns";

const XLSX = require('xlsx');

const date = Date().split(" ");
const dateStr = date[2] + date[1] + date[3];

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd/MM/yyyy");

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  let keys = Object.keys(array[0].latestAudit);
  //convert keys to formatted named table column names
  keys = keys.map((k) => {
    let key = {};
    key.value = k;
    key.name = k.replaceAll("_", " ");
    key.name = key.name.split(' ').map(str => (
      str.charAt(0).toUpperCase() + str.slice(1)
    )).join(' ');
    
    return key;
  })
  
  result = "";
  result += keys.map(k => k.name).join(columnDelimiter);
  result += lineDelimiter;
  
  array.forEach((item) => {
    
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item.latestAudit[key.value];

      ctr++;
    });

    if(item.oldAuditList.length > 0){
      
      item.oldAuditList.forEach(rcpt => {

        result += lineDelimiter;

        keys.forEach((key) => {

          result += rcpt[key.value];

          result += columnDelimiter;
    
          ctr++;
        });
        
      });
      
    }

    result += lineDelimiter;
  });
  
  return result;
};

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function downloadCSV(array) {
  const link = document.createElement("a");
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const date = Date().split(" ");
  // we use a date string to generate our filename.
  const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];

  const filename = `Receipt Tracking Report_${dateStr}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", filename);
  link.click();
};

function downloadEXCEL(array) {
  if(array && array.length === 0){
    return
  }
  
  let data = [];
  
  array.forEach((rcptObj) => {
    data.push(rcptObj.latestAudit);
    if(rcptObj.oldAuditList.length > 0){
      rcptObj.oldAuditList.forEach(auditRcpt => {
        data.push(auditRcpt);
      });
    }
  });

  let worksheet = XLSX.utils.json_to_sheet(data);
  var workBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workBook, worksheet, `Receipt Tracking ${dateStr}`);

  XLSX.writeFile(workBook, `Receipt Tracking ${dateStr}.xlsx`);
};

function downloadPDFReport(dataStr){

  if(!dataStr){
    alert("PDF Report was not generated.")
    return;
  }
  
  if (dataStr.length === 0){
    alert("PDF Report was not generated.")
    return;
  }
  const filename = `Receipt Tracking Report_${dateStr}.pdf`;
  const link = document.createElement("a");
  let data = 'data:application/pdf;base64,' + dataStr;
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
};

const Export = ({ onCSVExport, onPDFExport, pdfLoading, onXLSXExport }) => (
  <>
    <Button variant="primary" onClick={(e) => onCSVExport(e.target.value)} style={{fontSize: "14px"}}>
      CSV
    </Button>{" "}
    <Button variant="primary" onClick={(e) => onPDFExport(e.target.value)} style={{fontSize: "14px"}} disabled={pdfLoading}>
      PDF
    </Button>{" "}
    <Button variant="primary" onClick={(e) => onXLSXExport(e.target.value)} style={{fontSize: "14px"}}>
      EXCEL
    </Button>
  </>
);

const sortReportParams = (queryParams) => {
  let parameters = [
    {
      paramName: "p_receiptNumber",
      paramValue: queryParams.receiptNumber,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_mobileNumber",
      paramValue: queryParams.mobileNumber,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_departmentId",
      paramValue: queryParams.departmentId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_provinceId",
      paramValue: queryParams.provinceId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_provAgencyId",
      paramValue: queryParams.provAgencyId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_customerFirstName",
      paramValue: queryParams.customerFirstName,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_customerLastName",
      paramValue: queryParams.customerLastName,
      paramDataType: "java.lang.String"
    },
    {
      paramName: "p_serviceTypeId",
      paramValue: queryParams.serviceId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_serviceItemId",
      paramValue: queryParams.serviceItemId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_fromDate",
      paramValue: queryParams.fromIssuedDate,
      paramDataType: "java.sql.Date"
    },
    {
      paramName: "p_toDate",
      paramValue: queryParams.toIssuedDate,
      paramDataType: "java.sql.Date"
    },
    {
      paramName: "p_receiptStatusId",
      paramValue: queryParams.receiptStatusId,
      paramDataType: "java.lang.Integer"
    }
  ];

  parameters = parameters.filter((param) => param.paramValue !== "" && param.paramValue !== null && param.paramValue !== undefined );
  
  return parameters;
};

const columns = [
  {
    name: "Receipt No.",
    selector: (row) => row.latestAudit.rcpt_number,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.latestAudit.rcpt_status_desc,
    sortable: true,
  },
  {
    name: "Service Type",
    selector: (row) => row.latestAudit.service_name,
    sortable: true,
  },
  {
    name: "Customer",
    selector: (row) => row.latestAudit.cust_first_name + " " + row.latestAudit.cust_last_name,
    sortable: true,
  },
  {
    name: "Mobile No.",
    selector: (row) => row.latestAudit.cust_msisdn,
    sortable: true,
  },
  {
    name: "Department",
    selector: (row) => row.latestAudit.dept_name,
    sortable: true,
  },
  {
    name: "Province",
    selector: (row) => row.latestAudit.province_name,
    sortable: true,
  },
  {
    name: "Amount",
    selector: (row) => moneyFormater.format(row.latestAudit.total_amnt),
    sortable: true,
  },
  {
    name: "Date",
    selector: (row) => row.latestAudit.rcpt_issued_date,
    sortable: true,
  },
];

const dataTableStyles = {
  rows: {
    style: {
      fontSize: "16px"
    },
  },
  headCells: {
    style: {
      fontSize: "16px"
    },
  },
  cells: {
    style: {
      fontSize: "16px"
    },
  },
  pagination: {
    style: {
      fontSize: "16px"
    }
  }
};

export function ReceiptTrackingTable() {

  const dispatch = useDispatch();

  const { receiptTracking, auth } = useSelector((state) => state);
  
  const { listLoading, sortedReceipts, pdfReceiptReportStr, pdfReportLoading, receiptsMaxLimit, receiptMaxErrorMsg } = receiptTracking;
  const { user } = auth;
  
  let provAgencyId = user.prov_agency_id;

  const [ showRcptLimitErr, setShowRcptLimitErr ] = useState(false);
  
  const actionsMemo = useMemo(
    () => (
      <Export
        onPDFExport={() => downloadPDFReport(pdfReceiptReportStr)}
        pdfLoading={pdfReportLoading}
        onCSVExport={() => downloadCSV(sortedReceipts)}
        onXLSXExport={() => downloadEXCEL(sortedReceipts)}
      />
    ),
    [sortedReceipts, pdfReceiptReportStr, pdfReportLoading]
  );


  useEffect(() => {
    dispatch(rtReducerActions.clearReportString());
    dispatch(actions.fetchReceipts(provAgencyId, {
      fromIssuedDate: formatPresentDate,
      toIssuedDate: formatPresentDate
    }));
  }, [dispatch, provAgencyId]);

  useEffect(() => {
    if(receiptsMaxLimit){
      setShowRcptLimitErr(true);
      setTimeout(() => {
        dispatch(rtReducerActions.clearReceiptMaxLimit());
        setShowRcptLimitErr(false);
      }, 8000);
    } else {
      setShowRcptLimitErr(false);
    }
  }, [receiptsMaxLimit, dispatch, receiptMaxErrorMsg]);

  const closeAlert = () => {
    dispatch(rtReducerActions.clearReceiptMaxLimit());
    setShowRcptLimitErr(false);
  };

  const handleSearch = (queryParams) => {
    dispatch(rtReducerActions.clearReportString());
    handleSearchReceipt(queryParams);
    handlePDFReport(queryParams);
  };

  const handleSearchReceipt = (queryParams) => {
    dispatch(actions.findReceipts(provAgencyId, queryParams));
  };

  const handlePDFReport = (queryParams) => {
    
    getJasperPDFReport(queryParams);
  };

  const getJasperPDFReport = (queryParams) => {
    let definedParams = sortReportParams(queryParams);

    let reportQueryParams = {
      reportFileNameWithExt: "agency-receipt-tracking-report.jrxml",
      parameters: definedParams,
      generatedFileName: `Receipt Tracking Report ${dateStr}`,
      reportOutputTypeCode: "PDF",
      saveFile: false
    };

    dispatch(actions.receiptsPDFReport(reportQueryParams));
  };

  return (
    <div className="card card-custom card-stretch gutter-b">
      {/* begin::Header */}

      {/* end::Header */}

      {/* begin::Body */}
      {
        showRcptLimitErr ?
        <div className="d-flex justify-content-end">
          <Alert variant="info" transition={Fade} onClose={closeAlert} dismissible style={{ width: "50%", zIndex: 2, position: "absolute" }} >
            <Alert.Heading > Maximum Receipt Records Reached </Alert.Heading>
            <p>
              <b> {receiptMaxErrorMsg} </b>
              <br/>
              Adjust your search parameters to make a narrow or specific search for receipt records.
            </p>
          </Alert>
        </div>
        : null  
      }

      <div className="card-body py-6">
        <div className="row justify-content-start">
          <div className="col-12">
            <ReceiptTrackingSearchForm
              onHandleSearchReceipt={handleSearch}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {/* begin::Table */}
            <DataTable
              title={<h4>Receipts</h4>}
              customStyles={dataTableStyles}
              columns={columns}
              data={sortedReceipts}
              actions={actionsMemo}
              progressPending={listLoading}
              progressComponent={<Spinner animation="border" variant="primary" size="lg" />}
              expandableRows
              expandableRowsComponent={ReceiptDetails}
              expandOnRowClicked
              pagination
              highlightOnHover
              pointerOnHover
            />
            {/* end::Table */}
          </div>
        </div>
      </div>
      {/* end::Body */}
    </div>
  );
}
